/**
 * Generic filter functions for different item types
 */

/**
 * Filter function for products
 * @param {Product} product - The product to filter
 * @param {string} searchTerm - The search term to match against
 * @returns {boolean} - Whether the product matches the search term
 */
export const filterProducts = (product, searchTerm) => {
  const term = searchTerm.toLowerCase();
  return product.name.toLowerCase().includes(term) ||
         (product.publisher && product.publisher.toLowerCase().includes(term)) ||
         (product.year && product.year.toString().includes(term)) ||
         (product.description && product.description.toLowerCase().includes(term));
};

/**
 * Filter function for insert sets
 * @param {InsertSet} insertSet - The insert set to filter
 * @param {string} searchTerm - The search term to match against
 * @returns {boolean} - Whether the insert set matches the search term
 */
export const filterInsertSets = (insertSet, searchTerm) => {
  const term = searchTerm.toLowerCase();
  return insertSet.name.toLowerCase().includes(term) ||
         (insertSet.description && insertSet.description.toLowerCase().includes(term));
};

/**
 * Filter function for cards
 * @param {Card} card - The card to filter
 * @param {string} searchTerm - The search term to match against
 * @returns {boolean} - Whether the card matches the search term
 */
export const filterCards = (card, searchTerm) => {
  const term = searchTerm.toLowerCase();
  return card.name.toLowerCase().includes(term) ||
         (card.cardNumber && card.cardNumber.toLowerCase().includes(term)) ||
         (card.serialNumber && card.serialNumber.toLowerCase().includes(term)) ||
         (card.description && card.description.toLowerCase().includes(term));
};